import React from 'react';
import PropTypes from 'prop-types';

import { Grid, Paper, Typography, Box } from '@mui/material';

import IconOffer from 'app/components/customSvgs/IconOffer';
import PhoneListingCard from 'app/components/PhoneListingCard';

import { dateStamp } from 'app/helpers/timestampHelpers';

const SeekerAdvisorOfferCard = ({ offer }) => {
  return (
    <Paper sx={{ pb: 0, mb: 1.5, backgroundColor: '#eee' }} elevation={0}>
      <Box sx={{ maxWidth: 330, mx: 'auto', textAlign: 'center' }}>
        <Grid
          container
          alignItems="center"
          justifyContent="flex-start"
          sx={{
            color: '#ef8d34',
            p: 0.5,
            backgroundColor: 'white',
            border: '1px dotted #ef8d34',
          }}
        >
          <Grid item sx={{ ml: 1, mr: 1.5 }}>
            <IconOffer htmlColor="#ef8d34" sx={{ fontSize: 28 }} />
          </Grid>
          <Grid item sx={{ textAlign: 'left' }}>
            <Typography variant="subtitle1" sx={{ color: '#ef8d34', mb: -0.5 }}>
              Flirt offer -&nbsp;
              <strong>
                {offer.amount}
                &nbsp;free minutes
              </strong>
            </Typography>
            <Typography variant="body3" sx={{ color: '#999' }}>
              Expires&nbsp;
              {dateStamp(offer.expires_at)}
            </Typography>
          </Grid>
        </Grid>

        <PhoneListingCard listing={offer.listing} onDetailsClick={() => {}} />

      </Box>
    </Paper>
  );
};

SeekerAdvisorOfferCard.propTypes = {
  offer: PropTypes.object.isRequired,
};

export default SeekerAdvisorOfferCard;
